import dragula from 'dragula/dist/dragula.js';

'use strict';

var ad_itemCollection = function () {
  var self = this;

  self.init();
  self.bind();
};


ad_itemCollection.prototype.init = function () {
  var self = this;

  // console.log('init ad_itemCollection');

  self.init_th_normal();
  self.init_th_sortable();

};

ad_itemCollection.prototype.bind = function () {
  var self = this;

  // console.log('bind ad_itemCollection');

  jQuery(document).arrive('.ad_itemCollection', function (localSelf) {
    localSelf.init_th_sortable();
  }.bind(null, self));

};

ad_itemCollection.prototype.init_th_normal = function () {
  var self = this;

  var containers = jQuery('.ad_itemCollection').not('.th_sortable');

  containers.each(
    function (/*index*/) {
      var element = jQuery(this);

      var sortable = element.find('.ad_itemCollection_el_container');

      if (element.hasClass('st_mounted') === false) {


        // Delete an Item from the list:
        sortable.on(
          'ad_item.delete',
          // '.ad_item',
          function ( event ) {

            var item_container = event.target.closest('.ad_itemCollection_el_itemContainer');

            jQuery(item_container).slideUp('fast', function (localSelf, local_item_container/*, localElement*/) {

              // Eliminamos el content que ha sido pulsado por el usuario:
              jQuery(local_item_container).remove();

            }.bind(null, self, item_container, this));

          }
        );


        // Mark Element as mounted for future initializations
        element.addClass('st_mounted');
      }
    }
  );

};

ad_itemCollection.prototype.init_th_sortable = function () {
  var self = this;

  var containers = jQuery('.ad_itemCollection.th_sortable');

  containers.each(
    function (/*index*/) {
      var element = jQuery(this);

      var sortable = element.find('.ad_itemCollection_el_container');

      if (element.hasClass('st_mounted') === false) {
        dragula([sortable[0] ])
         .on('drop', function (localSelf, el, target/*, source, sibling*/) {

          localSelf.update_sortable(target);

        }.bind(null, self));
        // console.log(sortableCollection);

        // Update hidden field
        //self.update_sortable(sortable);

        // Delete an Item from the list:
        sortable.on(
          'ad_item.delete',
          // '.ad_item',
          function ( event ) {

            var item_container = event.target.closest('.ad_itemCollection_el_itemContainer');

            jQuery(item_container).slideUp('fast', function (localSelf, local_item_container, localElement) {

              // Eliminamos el content que ha sido pulsado por el usuario:
              jQuery(local_item_container).remove();

              // Actualizamos el listado de contents:
              localSelf.update_sortable(localElement);

            }.bind(null, self, item_container, this));

          }
        );

        // Add an Item to the list:
        element.on(
          'ad_itemCollection.add',
          // '.ad_item',
          function ( /*event*/ ) {


            // Lanzamos una llamada Ajax para obtener el html del nuevo Item:
            var ajax_url = '/admin_ajax_item_th_cardFull_01.html';

            jQuery.get( ajax_url, function(localSelf, localElement, data ) {

              // Inyectamos el html recibido desde la llamada Ajax
              var container = jQuery(localElement).find('.ad_itemCollection_el_container');

              var classes = container.find('.ad_itemCollection_el_itemContainer').attr('class');

              var div_item = jQuery('<div/>').addClass(classes);

              div_item.html(data);

              container.prepend(div_item);

              // Actualizamos el orden del listado de items
              self.update_sortable(container);

            }.bind(null, self, this));

          }
        );

        // Mark Element as mounted for future initializations
        element.addClass('st_mounted');
      }
    }
  );

};


ad_itemCollection.prototype.update_sortable = function (container) {
  //var self = this;

  // console.log('bracula out');
  // console.log(container);

  var id_string = '';

  var items = jQuery(container).find('.ad_item, .ad_card');

  for (var i = 0; i < items.length; ++i) {
    if (i === 0) {
      id_string = jQuery(items[i]).attr('id');
    } else {
      id_string = id_string + '@' + jQuery(items[i]).attr('id');
    }

  }


  // console.log('Nuevo orden del ad_itemCollection');
  // console.log(id_string);

  //ad_itemCollection_el_inputOrder

  var component_instance = jQuery(container.closest('.ad_itemCollection'));
  $.ajax({
    url: component_instance.data('url'),
    method: 'POST',
    data: {sort_data: id_string}
  });

  var inputOrder = component_instance.find('.ad_itemCollection_el_inputOrder');

  // Refresh the input hidden with the new Order
  inputOrder.val(id_string);

};







jQuery( document ).ready(function() {

  window.ad_itemCollection = new ad_itemCollection();

});
